import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormCaja06 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            
            fechaDesde: null,
            fechaHasta: null,
            anioActual: null,

            //CONTROL SOBRE PANTALLA
            control: 0,
        };

        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.generarRespaldoCobranza = this.generarRespaldoCobranza.bind(this);
    }

    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('05');
        let anio = fechaProceso.toString().split('/')

        this.setState({fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'), fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'), anioActual: anio[2]})
    }

    componentDidMount(){

        this.props.generar_LogAuditoriaIngresoForm('0506').then(()=>{  
            let fechaProceso = getFechaProcesoPorModulo('05');
            let anio = fechaProceso.toString().split('/')

            this.setState({fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'), fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'), anioActual: anio[2]})
        })
        .catch((error )=>{
            alert(error.response?error.response.data.msg:error.message);
            this.setState({control: 1});
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0506');
    }

    //Consulta DB
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Request de generacion de historial segun operacion
    genCobranzaTrabajo(){
        let data = {};

        data.FechaDesde = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)
        data.FechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
        data.Usuario = this.props.usuario;
        
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'POST',
            url: '/respaldo/cobranza',
            data
        })
        .then((response)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(response.data.msg)
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    //Boton Generar Respaldo según operacion x usuario
    generarRespaldoCobranza(){
        let fechaHasta = formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta);
        this.cargarObjetos(`/respaldo?desde=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}&hasta=${fechaHasta}&obj=cobranza`).then((exist)=>{
            if(exist.exist===true){
                let msj = window.confirm('Existe un corte para esta semana, ¿Sobreescribir?');
                if (msj){
                    this.genCobranzaTrabajo();
                }   
            }else{
                this.genCobranzaTrabajo();
            }
        })
        .catch((error)=>{
            alert("Ha ocurrido un error: " + error);
        });        
    }

    render(){
        return(
            <ContenedorForm porc_ancho={40}>
                <HeaderForm>
                    <TituloForm>Corte de cobranza</TituloForm>
                </HeaderForm>
                    <CuerpoForm>
                    <Row>                        
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='7'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.fechaDesde===null || this.state.fechaHasta===null || this.state.control===1?true:false} onClick={this.generarRespaldoCobranza}><i className="fa fa-database" aria-hidden="true"/> Generar</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                    </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
    
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCaja06);